/* eslint-disable no-useless-constructor */
/* eslint-disable no-empty-function */
/* eslint-disable no-use-before-define */
/* eslint-disable max-classes-per-file */
/* eslint-disable class-methods-use-this */

class Right<L, R> {
    constructor(readonly right: R) {}

    isRight(): this is Right<L, R> {
        return true
    }

    isLeft(): this is Left<L, R> {
        return false
    }
}

class Left<L, R> {
    constructor(readonly left: L) {}

    isRight(): this is Right<L, R> {
        return false
    }

    isLeft(): this is Left<L, R> {
        return true
    }
}

type EitherValue<L, R> = Right<L, R> | Left<L, R>

export default class Either<L, R> {
    // eslint-disable-next-line no-empty-function
    private constructor(readonly value: EitherValue<L, R>) {}

    fold<B, C>(leftFn: (left: L) => B, rightFn: (right: R) => C): B | C {
        if (this.value.isLeft()) return leftFn(this.value.left)
        return rightFn(this.value.right)
    }

    map<T>(fn: (r: R) => T): Either<L, T> {
        return this.flatMap((r) => Either.right(fn(r)))
    }

    flatMap<T>(fn: (right: R) => Either<L, T>): Either<L, T> {
        return this.fold(
            (leftValue) => Either.left(leftValue),
            (rightValue) => fn(rightValue)
        )
    }

    getOrThrow(errorMessage?: string): R {
        const throwFn = () => {
            throw Error(errorMessage || `An error has ocurred: ${this.value}`)
        }

        return this.fold(
            () => throwFn(),
            (rightValue) => rightValue
        )
    }

    getOrElse(defaultValue: R): R {
        return this.fold(
            () => defaultValue,
            (someValue) => someValue
        )
    }

    static left<A, B>(value: A): Either<A, B> {
        return new Either<A, B>(new Left(value))
    }

    static right<A, B>(value: B): Either<A, B> {
        return new Either<A, B>(new Right(value))
    }
}
